var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tags',{attrs:{"tooltip":_vm.tooltip,"tags":_vm.tags,"only-ats-tags":_vm.currentTeam.onlyAtsTags,"size":"small"},on:{"clicked":_vm.clickedTag,"added":_vm.addTag,"removed":_vm.removeTag}})
}
var staticRenderFns = []

export { render, staticRenderFns }